import Generator from '../generator';
import { api } from 'utils/api-client';

const config = {
  entities: {
    api: {
      fetchItem: (type, { websiteId, ...args }, id) =>
        api.get(`/websites/${websiteId}/popups/${id}`, args),
      updateItem: (type, { websiteId, ...args }, id) =>
        api.patch(`/websites/${websiteId}/popups/${id}`, args),
      fetchList: (type, { websiteId, ...args }) =>
        api.get(`/websites/${websiteId}/popups`, args),
      createItem: (type, { websiteId, ...args }) =>
        api.post(`/websites/${websiteId}/popups`, args)
    }
  }
};

export default new Generator('popups', config).createEntityModel();
